import React__default from 'react';
import styles from '../../components/atoms/progressbar/progressbar.module.scss.js';
import { Root as $67824d98245208a0$export$be92b6f5f03c0fe9, Indicator as $67824d98245208a0$export$adb584737d712b70 } from './../../external_lib/@radix-ui/react-progress/dist/index.js';
import classNames from './../../external_lib/classnames/index.js';
function ProgressBar(_a) {
  var _b = _a.className,
    className = _b === void 0 ? '' : _b,
    _c = _a.progress,
    progress = _c === void 0 ? 0 : _c,
    _d = _a.height,
    height = _d === void 0 ? 4 : _d,
    _e = _a.width,
    width = _e === void 0 ? 100 : _e;
  return React__default.createElement($67824d98245208a0$export$be92b6f5f03c0fe9, {
    className: classNames(styles.ProgressRoot, className),
    value: progress,
    style: {
      height: "".concat(height, "px"),
      width: Number.isInteger(width) ? "".concat(width, "%") : width
    }
  }, React__default.createElement($67824d98245208a0$export$adb584737d712b70, {
    className: classNames(styles.ProgressIndicator, className),
    style: {
      transform: "translateX(-".concat(100 - progress, "%)")
    }
  }));
}
export { ProgressBar as default };
//# sourceMappingURL=index.js.map
